module.exports = __webpack_public_path__ + "img/730.08892f4c.jpg";